module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('datatable', {
    attrs: {
      "columns": _vm.columns,
      "source": _vm.getRecords,
      "datachanged": _vm.refreshIndex
    },
    on: {
      "selected": _vm.recordSelected
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ac5802c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ac5802c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/FmdControls/BagList/baglist.scp.html
// module id = 525
// module chunks = 0